import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {Record} from '../../models/record.model';
import {groupsActiveUrl, oswUrl, recordGroupsUrl, recordsUrl, recordsUserUrl, recordsUserGroupsUrl} from '../api-url';

@Injectable({
    providedIn: 'root'
})
export class RecordsService {
    records: Record[] = [];
    respMsg: any = {};
    private updatedRecords = new Subject<any[]>();

    constructor(private http: HttpClient, private router: Router) {
    }

    // RECORD-ITEMS
    getSingle(id: string) {
        return this.http.get <any>(`${recordsUrl}/` + id);
    }

    allRecords() {
        return this.http.get<any>(recordsUrl);
    }

    userRecords(id) {
        return this.http.get<any>(`${recordsUserUrl}/` + id);
    }

    userRecordsGroups(id) {
        return this.http.get<any>(`${recordsUserGroupsUrl}/` + id);
    }

    postRecord(record) {
        this.http
            .post(`${recordsUrl}/`, record)
            .subscribe(responseData => {
                console.log('POST DATA', responseData);
                this.router.navigate(['/']);
            });
    }

    updateRecordItem(recordId, record) {
        this.http
            .put(`${recordsUrl}/` + recordId, record)
            .subscribe(response => {
                console.log('UPDATE RECORD RESPONSE', response);
                this.router.navigate(['/']);
            });
    }

    deleteRecord(recordId) {
        this.http.delete(`${recordsUrl}/` + recordId)
            .subscribe(response => {
                console.log('DEL RECORD RESPONSE', response);
                this.respMsg = response;
                this.router.navigate(['/temp']);
            });
    }

    // OWS-RECORDS
    postOSW(record) {
        console.log('DATA OSW', record);
        this.http
            .post(`${oswUrl}/`, record
            )
            .subscribe(responseData => {
                console.log('POST OSW DATA', responseData);
                this.router.navigate(['/']);
            });
    }

    updateOSW(recordId, osw) {
        console.log('ID', recordId, 'REC', osw);
        this.http
            .put(`${oswUrl}/` + recordId, osw)
            .subscribe(response => {
                console.log('OSW UPDATE RESPONSE', response);
                this.router.navigate(['/']);
            });
    }

    // GROUPS-RECORDS
    getGroupsRecords() {
        return this.http.get<any[]>(recordGroupsUrl);
    }

    getGroupWithRecords(id) {
        return this.http.get <any>(`${groupsActiveUrl}/` + id);
    }

    postGroupRecord(record) {
        console.log('DATA', record);
        this.http
            .post(`${groupsActiveUrl}/`, record)
            .subscribe(responseData => {
                console.log('GROUP RECORDS', responseData);
                this.router.navigate(['/']);
            });
    }

    updateGroupRecords(groupId, record) {
        console.log('ON SERVICE', groupId, record);
        this.http
            .put(`${groupsActiveUrl}/` + groupId, record)
            .subscribe(response => {
                console.log('Updated Group Response', response);
                this.router.navigate(['/']);
            });
    }

    updateGroupStatus(groupId, group) {
        console.log('Group Status', groupId, group);
        this.http
            .put(`${recordGroupsUrl}/` + groupId, group)
            .subscribe(response => {
                console.log('Group Status Has Been Updated', response);
                this.router.navigate(['/']);
            });
    }

    // getUpdatedRecordsListener() {
    //   return this.updatedRecords.asObservable();
    // }
}
